// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__IXd5s","innerContainer":"styles_innerContainer__mXtID","catalogInfo":"styles_catalogInfo__VWQTW","catalogText":"styles_catalogText__w7RuB","icon":"styles_icon__WHopQ"};
module.exports.__checksum = "737253ddceee"